import _ from 'lodash'

global._ = _